import React from "react";
import { useTranslation } from "react-i18next";

import { CallsSection } from "./CallsSection";
import { useFacilityReport } from "./hook";
import { OverallAISummarySection } from "./OverallAISummarySection";
import { ReviewsSection } from "./ReviewsSection";
import { RouteSearchSection } from "./RouteSearchSection";
import { SearchKeywordsSection } from "./SearchKeywordsSection";
import { WebsiteSection } from "./WebsiteSection";
import { AccountType } from "../../../models/AccountData";
import { OptionalRender } from "../../Common/OptionalRender";

import "./styles.scss";

interface IFacilityReportDetailsProps {
  facilityReportId: string;
}

export const FacilityReportDetails: React.FunctionComponent<
  IFacilityReportDetailsProps
> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityReportsPage.facilityReportDetails.${key}`);

  const { facilityReportId } = props;

  const { data: facilityReport, isLoading } =
    useFacilityReport(facilityReportId);

  const reportData =
    facilityReport?.location_facility_reports_report_data?.data;

  // TODO: Implement download
  const handleDownload = () => {
    alert("download not yet implemented");
  };

  // TODO: Implement edit
  const handleEdit = () => {
    alert("edit not yet implemented");
  };

  return (
    <div className="facility-report-details">
      <div className="facility-report-details-title">
        <h2>{facilityReport?.location?.name}</h2>
      </div>
      <div className="line"></div>
      <div className="facility-report-details-controls">
        <span>TODO: Select Report (same location) Here</span>
        <button className="btn btn-blue" type="button" onClick={handleDownload}>
          {t("download")}
        </button>
        <OptionalRender mustBeOneOfRoles={[AccountType.ADMIN]}>
          <button className="btn btn-border" type="button" onClick={handleEdit}>
            {t("edit")}
          </button>
        </OptionalRender>
      </div>
      {isLoading ? (
        <div className="loading-container">
          <div className="loading-spinner"></div>
        </div>
      ) : (
        <div className="facility-report-details-content">
          <SearchKeywordsSection
            searchKeywords={reportData?.search_keywords}
            startDate={facilityReport?.start_date}
            endDate={facilityReport?.end_date}
          />
          <WebsiteSection website={reportData?.website} />
          <CallsSection calls={reportData?.calls} />
          <RouteSearchSection routeSearch={reportData?.route_search} />
          <ReviewsSection reviews={reportData?.reviews} />
          <OverallAISummarySection
            overallAISummary={reportData?.overall_ai_summary}
          />
        </div>
      )}
    </div>
  );
};
